import dateCss from "./rootCss.json";

export function  getRootCssCorporation(idCorporation){
    var id = idCorporation;
    var configurationCorpo = dateCss.map((item) => {
      if(item.idCorporation == id)
        return item;
    }).find(x => x != undefined);
    
    if(configurationCorpo){
       var root = document.querySelector(':root');            
               
        root.style.setProperty('--primaryColor', configurationCorpo.primaryColor);
        root.style.setProperty('--secondaryColor', configurationCorpo.secondaryColor);
        root.style.setProperty('--secondaryText', configurationCorpo.secondaryText);
        root.style.setProperty('--highlightColor', configurationCorpo.highlightColor);
        root.style.setProperty('--highlightText', configurationCorpo.highlightText);
        root.style.setProperty('--textLinkColor', configurationCorpo.textLinkColor);
        root.style.setProperty('--bannerHomeTxt', configurationCorpo.bannerHomeTxt);
        root.style.setProperty('--footerSocial', configurationCorpo.footerSocial);
        root.style.setProperty('--mainFont', configurationCorpo.mainFont);
        root.style.setProperty('--primaryText', configurationCorpo.primaryText);
        root.style.setProperty('--searchHomeColor', configurationCorpo.searchHomeColor);
        root.style.setProperty('--searchHomeText', configurationCorpo.searchHomeText);
    }     

    return configurationCorpo;
  }